module.exports = __webpack_public_path__ + "static/media/Logo-ezra.d3758264.jpg";